import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import React from 'react';
import classnames from 'classnames';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import VisuallyHidden from '@wix/da-a11y/pkg/components/VisuallyHidden';
import HoverableWrapper from '@wix/da-ds/pkg/thumbs/OverlayHelpers/HoverableWrapper';
import { useOverlayContext } from '../../../hooks/useOverlayContext';
import ErrorBoundary from '../../../../ErrorBoundary';
import DeviationDumbView from '../../../Dumbo';
import DeviationLink from '../../../../Duperbrowse/DeviationLink';
import { DeviationTypes } from '../../../../types/deviation';
import { useTranslation } from 'react-i18next';
import { getTranslationKeyForAccessibleDeviationLink } from '../../helpers';
import Overlay from '../../legos/Overlay';
import { BiDataHook } from '@wix/da-bi/pkg/constants';
import { getDeviationType } from '../../../_helpers';
import useDeviationDrag from '../../../../Dnd/useDeviationDrag';
import s from './Default.scss';
const Default = ({ className, deviation, height, responsive, style, width, extraActions, onRemove })=>{
    const { t } = useTranslation();
    const { showTitle: showOverlayTitle, showOverlay, thumbClickAction, __forceHoveredForStories } = useOverlayContext(deviation);
    const { dragPreview, drag } = useDeviationDrag({
        deviation,
        width,
        height
    });
    const type = getDeviationType(deviation);
    const linkAsWrapper = type === DeviationTypes.IMAGE;
    const a11yLabel = getTranslationKeyForAccessibleDeviationLink(t, deviation);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, dragPreview, /*#__PURE__*/ React.createElement(HoverableWrapper, {
        className: classnames(s['root'], className),
        style: _object_spread({
            width,
            height
        }, style),
        "data-hook": BiDataHook.DEVIATION_STD_THUMB,
        ref: drag,
        __forceHoveredForStories: __forceHoveredForStories
    }, /*#__PURE__*/ React.createElement(ErrorBoundary, {
        debugComponent: "StandardThumbDefault"
    }, /*
            Because we don't always show a title inside of the overlay,
            we'll place this here to avoid any untitled sections polluting the document outline
          */ !showOverlayTitle && /*#__PURE__*/ React.createElement(VisuallyHidden, null, /*#__PURE__*/ React.createElement(Heading, null, a11yLabel)), linkAsWrapper ? /*#__PURE__*/ React.createElement(DeviationLink, {
        "aria-label": a11yLabel,
        deviation: deviation,
        overrideAction: thumbClickAction
    }, /*#__PURE__*/ React.createElement(DeviationDumbView, {
        deviation: deviation,
        width: width,
        height: height,
        responsive: responsive,
        // We'll rely on the link to inform screen readers
        "aria-hidden": "true"
    })) : /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(DeviationDumbView, {
        deviation: deviation,
        width: width,
        height: height,
        responsive: responsive,
        // We'll rely on the link to inform screen readers
        "aria-hidden": "true"
    }), /*#__PURE__*/ React.createElement(DeviationLink, {
        deviation: deviation,
        className: s['link-overlay'],
        title: deviation.title,
        "aria-label": a11yLabel,
        overrideAction: thumbClickAction
    }, /*#__PURE__*/ React.createElement("span", null))), showOverlay && /*#__PURE__*/ React.createElement(Overlay, {
        deviation: deviation,
        width: width,
        height: height,
        className: s['overlay'],
        extraActions: extraActions,
        "aria-hidden": "true",
        onRemove: onRemove
    }))));
};
Default.displayName = 'Default';
export default Default;
